export const findDifferences = (obj1, obj2, path = ''): string[] => {
  let differences: string[] = [];

  // Ensure both inputs are objects, else compare directly
  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    if (obj1 !== obj2) {
      return [path];
    }
    return [];
  }

  // Combine keys from both objects to ensure no property is missed
  const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

  keys.forEach((key) => {
    const newPath = path ? `${path}.${key}` : key;

    // If both properties are objects, recurse
    if (obj1[key] instanceof Object && obj1[key] !== null && obj2[key] instanceof Object && obj2[key] !== null) {
      differences = differences.concat(findDifferences(obj1[key], obj2[key], newPath));
    } else if (obj1[key] !== obj2[key]) {
      // Direct comparison for non-object properties like 'name' or 'crated_at'
      differences.push(newPath);
    }
  });
  return differences;
};
